import type { FC, ReactElement, ReactNode } from 'react';
import { Modal } from 'antd';

type ConfirmActionButtonProps = {
  cancelText?: string;
  confirmText?: string;
  danger?: boolean;
  description: string | ReactNode;
  okTestId?: string;
  onConfirm: () => Promise<void> | void;
  stopPropagation?: boolean;
  title: string;
  trigger: ReactElement;
};

const { useModal } = Modal;

export const ConfirmActionButton: FC<ConfirmActionButtonProps> = ({
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  danger = false,
  description,
  okTestId,
  onConfirm,
  stopPropagation = true,
  title,
  trigger,
}) => {
  const [modal, contextHolder] = useModal();

  const showConfirm = () => {
    modal.confirm({
      cancelText,
      content: description,
      icon: null,
      okButtonProps: { danger, ...(okTestId ? { 'data-testid': okTestId } : {}) },
      okText: confirmText,
      onOk: onConfirm,
      title,
    });
  };

  return (
    <div onClick={(e) => stopPropagation && e.stopPropagation()}>
      {contextHolder}
      <span
        onClick={(e) => {
          if (stopPropagation) e.stopPropagation();
          showConfirm();
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            showConfirm();
          }
        }}
      >
        {trigger}
      </span>
    </div>
  );
};
